import * as React from 'react';
import { TiptapButton } from '../TiptapButton';
import Lift from 'Shared/icons/lift.svg';
import { useEditorContext } from '../../editor_context';

export const UnindentButton = props => {
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().liftListItem('listItem').run()}
         isDisabled={!editor.can().liftListItem('listItem')}
         icon={<Lift />}
         title={_js('Decrease indent')}
         overrideShortcut={'shift+tab'}
      />
   );
};
